<script setup lang="ts">

defineProps({
  text: {
    type: String,
    required: true
  }
})

</script>

<template>
  <div class="flex bg-slate-800 rounded items-center w-fit">
    <div class="bg-slate-700 bg-opacity-80 text-slate-300 p-1 rounded-s px-2">{{ text }}</div>
    <div class="bg-slate-900 bg-opacity-50 p-1 rounded-e px-2 flex-grow text-right">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>